import { useQuery } from 'react-query'
import React from "react";
import { fetchTrialSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function TotalsByRepWithRegion({ date }) {
    const fetchData = async () => {
        const { data } = await fetchTrialSignUpsExplorer('totalsByRepWithRegion', date);
        if (data.result && data.result.data) return data.result;
        return { ...data.result, data: [] }; // Ensure data is always an array
    };

    const { data, error, isError, isLoading } = useQuery(
        ['totalsByRepWithRegion', date],
        fetchData,
        {
            refetchOnWindowFocus: false,
        }
    );
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={"totalsByRepWithRegion" + date}  {...dataProps } />
}
export default TotalsByRepWithRegion